import React, { useState } from 'react';
import ProfileSection from '../components/settings/ProfileSection';
import PasswordSection from '../components/settings/PasswordSection';
import PeopleSection from '../components/settings/PeopleSection';
import ClientsSection from '../components/settings/ClientsSection';
import CategoriesSection from '../components/settings/CategoriesSection';
import LoginInfoSection from '../components/settings/LoginInfoSection';
import UsersSection from '../components/settings/UsersSection';

// Settings split into tabs. Admin-only tabs (people, categories, login message) are hidden for everyone else; the server
// still checks admin rights on the corresponding writes.
export default function Settings({ loggedInUser, isAdmin: isAdminProp }) {
  const isAdmin = Boolean(isAdminProp) || loggedInUser === 'Tomo';
  const tabs = [
    { id: 'profile', label: 'My profile', render: () => <ProfileSection loggedInUser={loggedInUser} /> },
    { id: 'password', label: 'Password', render: () => <PasswordSection loggedInUser={loggedInUser} /> },
    // Every designer may add clients.
    { id: 'clients', label: 'Clients', render: () => <ClientsSection /> },
    ...(isAdmin ? [
      { id: 'people', label: 'People', render: () => <PeopleSection loggedInUser={loggedInUser} /> },
      { id: 'categories', label: 'Categories', render: () => <CategoriesSection loggedInUser={loggedInUser} /> },
      { id: 'users', label: 'Users', render: () => <UsersSection loggedInUser={loggedInUser} /> },
      { id: 'login', label: 'Login message', render: () => <LoginInfoSection loggedInUser={loggedInUser} /> },
    ] : []),
  ];
  const [active, setActive] = useState('profile');
  const current = tabs.find((t) => t.id === active) || tabs[0];

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Settings</h2>
      <div role="tablist" className="flex flex-wrap gap-1 border-b mb-4">
        {tabs.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={t.id === current.id}
            onClick={() => setActive(t.id)}
            className={`px-4 py-2 -mb-px border-b-2 ${t.id === current.id
              ? 'border-indigo-600 font-semibold text-indigo-700 dark:text-indigo-300'
              : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white'}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="bg-white dark:bg-gray-800 rounded shadow p-4">{current.render()}</div>
    </div>
  );
}
